import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import { FiUploadCloud, FiDownload, FiEdit, FiTrash2, FiPlus, FiMinus, FiX, FiEye, FiRefreshCw } from 'react-icons/fi';

const DiagnosticDetail = () => {
  const { id } = useParams();
  const [diagnostic, setDiagnostic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("basic");

  // Base URL for images
  const BASE_URL = "https://api.elthiumhealth.com";
  const API_BASE = "https://api.elthiumhealth.com/api/admin";

  // Edit states for different entities
  const [editingTest, setEditingTest] = useState(null);
  const [editingPackage, setEditingPackage] = useState(null);
  const [editingScan, setEditingScan] = useState(null);
  const [editingContact, setEditingContact] = useState(null);
  const [editingSlot, setEditingSlot] = useState(null);

  // Edit forms - UPDATED WITH GENDER
  const [testForm, setTestForm] = useState({
    name: "",
    price: "",
    description: "",
    instruction: "",
    fastingRequired: false,
    homeCollectionAvailable: false,
    reportIn24Hrs: false,
    reportHour: "",
    category: "",
    precaution: "",
    gender: "Both" // Added gender field
  });

  const [packageForm, setPackageForm] = useState({
    name: "",
    price: "",
    totalTestsIncluded: "",
    description: "",
    precautions: "",
    gender: "Both", // Added gender field
    includedTests: []
  });

  const [scanForm, setScanForm] = useState({
    title: "",
    price: "",
    preparation: "",
    reportTime: "",
    image: "",
    gender: "Both" // Added gender field
  });

  const [contactForm, setContactForm] = useState({
    name: "",
    designation: "",
    gender: "",
    contactEmail: "",
    contactNumber: ""
  });

  // Slot states
  const [slotForm, setSlotForm] = useState({
    day: "",
    date: "",
    timeSlot: "",
    isBooked: false,
    slotType: "home",
    gender: "Both" // Added gender field
  });

  // Add modal states
  const [showAddPackageModal, setShowAddPackageModal] = useState(false);
  const [showAddTestModal, setShowAddTestModal] = useState(false);
  const [showAddScanModal, setShowAddScanModal] = useState(false);
  const [showAddBranchModal, setShowAddBranchModal] = useState(false);
  const [editingBranch, setEditingBranch] = useState(null);

  // New forms - UPDATED WITH GENDER
  const [newPackageForm, setNewPackageForm] = useState({
    name: "",
    price: "",
    totalTestsIncluded: "",
    description: "",
    precautions: "",
    gender: "Both", // Added gender field
    includedTests: [{ name: "", subTestCount: 0, subTests: [""] }]
  });

  const [newTestForm, setNewTestForm] = useState({
    test_name: "",
    price: "",
    description: "",
    instruction: "",
    fastingRequired: false,
    homeCollection: false,
    reportIn24Hrs: false,
    reportHour: "",
    category: "General",
    precautions: "",
    gender: "Both" // Added gender field
  });

  const [newScanForm, setNewScanForm] = useState({
    title: "",
    price: "",
    preparation: "",
    reportTime: "",
    category: "",
    gender: "Both", // Added gender field
    image: null
  });

  const [branchForm, setBranchForm] = useState({
    branchName: "",
    email: "",
    phone: "",
    address: "",
    locationUrl: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    gender: "Both", // Added gender field for branch
    contactPersons: [{ name: "", designation: "", gender: "", contactEmail: "", contactNumber: "" }]
  });


  // Bulk update slots states
const [bulkUpdateForm, setBulkUpdateForm] = useState({
  slotType: "home", // "home" or "center"
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
  timeGap: 30, // minutes
  gender: "Both",
  operation: "update" // "update" or "delete"
});

  useEffect(() => {
  const fetchDiagnosticDetails = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await axios.post(
        `${API_BASE}/diagnostics`,
        { id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setDiagnostic(response.data.diagnostic);
    } catch (err) {
      setError("Failed to fetch diagnostic details");
      console.error(
        "Error fetching diagnostic:",
        err.response?.data || err.message
      );
    } finally {
      setLoading(false);
    }
  };

  fetchDiagnosticDetails();
}, [id]);

  // Add Slot - UPDATED WITH GENDER
  const addSlot = async () => {
  try {
    const token = localStorage.getItem("authToken");

    const res = await axios.put(
      `${API_BASE}/add-slotfordiag`,
      {
        diagnosticId: diagnostic._id,
        slotType: slotForm.slotType,
        day: slotForm.day,
        date: slotForm.date,
        timeSlot: slotForm.timeSlot,
        isBooked: slotForm.isBooked,
        gender: slotForm.gender,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire("Success", "Slot added successfully", "success");

    setDiagnostic(res.data.diagnostic);

    setSlotForm({
      day: "",
      date: "",
      timeSlot: "",
      isBooked: false,
      slotType: "home",
      gender: "Both",
    });
  } catch (err) {
    console.error(
      "Add slot error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to add slot", "error");
  }
};

  // Update Slot - UPDATED WITH GENDER
  const handleEditSlot = (slot, type) => {
    setEditingSlot(slot);
    setSlotForm({
      day: slot.day || "",
      date: slot.date || "",
      timeSlot: slot.timeSlot || "",
      isBooked: slot.isBooked || false,
      slotType: type,
      gender: slot.gender || "Both" // Added gender
    });
  };

  // Frontend में updateSlot function
const updateSlot = async () => {
  if (!editingSlot) {
    Swal.fire("Error", "No slot selected for update", "error");
    return;
  }

  try {
    const token = localStorage.getItem("authToken");

    const payload = {
      diagnosticId: diagnostic._id,
      slotType: slotForm.slotType,
      slotId: editingSlot._id,
      newSlot: {
        newDay: slotForm.day,
        newDate: slotForm.date,
        newTimeSlot: slotForm.timeSlot,
        isBooked: slotForm.isBooked || false,
      },
    };

    console.log("Final payload to send:", payload);

    const res = await axios.put(
      `${API_BASE}/update-slot`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire("Success", "Slot updated successfully", "success");

    // Reset states
    setEditingSlot(null);
    setSlotForm({
      day: "",
      date: "",
      timeSlot: "",
      isBooked: false,
      slotType: "home",
    });

    // Update local state
    setDiagnostic(res.data.diagnostic);
  } catch (err) {
    console.error(
      "Update slot error:",
      err.response?.data || err.message
    );

    const errorMessage =
      err.response?.data?.message ||
      err.response?.data?.error ||
      "Failed to update slot";

    Swal.fire("Error", errorMessage, "error");
  }
};


  const deleteSlot = async (slot, type) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (!result.isConfirmed) return;

  try {
    const token = localStorage.getItem("authToken");
    const slotType = type === "home" ? "home" : "center";

    const res = await axios.put(
      `${API_BASE}/delete-diagslot`,
      {
        diagnosticId: diagnostic._id,
        slotType,
        day: slot.day,
        date: slot.date,
        timeSlot: slot.timeSlot,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire("Deleted!", "Slot has been deleted.", "success");
    setDiagnostic(res.data.diagnostic);
    setEditingSlot(null);
  } catch (err) {
    console.error(
      "Delete slot error:",
      err.response?.data || err.message
    );

    Swal.fire(
      "Error",
      err.response?.data?.message || "Failed to delete slot",
      "error"
    );
  }
};

  // Test CRUD Operations - UPDATED WITH GENDER
  const handleEditTest = (test) => {
    setEditingTest(test);
    setTestForm({
      name: test.name || "",
      price: test.price || "",
      description: test.description || "",
      instruction: test.instruction || "",
      fastingRequired: test.fastingRequired || false,
      homeCollectionAvailable: test.homeCollectionAvailable || false,
      reportIn24Hrs: test.reportIn24Hrs || false,
      reportHour: test.reportHour || "",
      category: test.category || "",
      precaution: test.precaution || "",
      gender: test.gender || "Both" // Added gender
    });
  };

  const handleUpdateTest = async () => {
  try {
    const token = localStorage.getItem("authToken");

    const res = await axios.put(
      `${API_BASE}/updatetest`,
      {
        testId: editingTest._id,
        ...testForm,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire("Success", "Test updated successfully", "success");
    setEditingTest(null);

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Update test error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to update test", "error");
  }
};

  const handleDeleteTest = async (testId) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This test will be deleted!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (!result.isConfirmed) return;

  try {
    const token = localStorage.getItem("authToken");

    await axios.delete(`${API_BASE}/deletetest`, {
      data: {
        testId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    Swal.fire("Deleted!", "Test has been deleted.", "success");

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Delete test error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to delete test", "error");
  }
};

  // Add Test Function - UPDATED WITH GENDER
  const handleCreateTest = async () => {
  try {
    const token = localStorage.getItem("authToken");

    const payload = {
      name: newTestForm.test_name,
      price: newTestForm.price,
      description: newTestForm.description,
      instruction: newTestForm.instruction,
      fastingRequired: newTestForm.fastingRequired,
      homeCollectionAvailable: newTestForm.homeCollection,
      reportIn24Hrs: newTestForm.reportIn24Hrs,
      reportHour: newTestForm.reportHour,
      category: newTestForm.category,
      precaution: newTestForm.precautions,
      gender: newTestForm.gender,
      diagnosticIds: [diagnostic._id],
    };

    const res = await axios.post(
      `${API_BASE}/create-test`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire("Success", "Test created successfully", "success");

    setNewTestForm({
      test_name: "",
      price: "",
      description: "",
      instruction: "",
      fastingRequired: false,
      homeCollection: false,
      reportIn24Hrs: false,
      reportHour: "",
      category: "General",
      precautions: "",
      gender: "Both",
    });

    setShowAddTestModal(false);

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Create test error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to create test", "error");
  }
};

  // Package CRUD Operations - UPDATED WITH GENDER
  const handleEditPackage = (pkg) => {
    setEditingPackage(pkg);
    setPackageForm({
      name: pkg.name || "",
      price: pkg.price || "",
      totalTestsIncluded: pkg.totalTestsIncluded || "",
      description: pkg.description || "",
      precautions: pkg.precautions || "",
      gender: pkg.gender || "Both", // Added gender
      includedTests: Array.isArray(pkg.includedTests) ? pkg.includedTests.map(test => ({
        name: test.name || "",
        subTestCount: test.subTestCount || 0,
        subTests: Array.isArray(test.subTests) ? [...test.subTests] : [""]
      })) : [{ name: "", subTestCount: 0, subTests: [""] }]
    });
  };

  const handlePackageTestChange = (index, field, value) => {
    const updatedTests = [...packageForm.includedTests];
    updatedTests[index][field] = field === "subTestCount" ? parseInt(value) || 0 : value;
    setPackageForm({ ...packageForm, includedTests: updatedTests });
  };

  const handlePackageSubTestChange = (testIndex, subTestIndex, value) => {
    const updatedTests = [...packageForm.includedTests];
    updatedTests[testIndex].subTests[subTestIndex] = value;
    setPackageForm({ ...packageForm, includedTests: updatedTests });
  };

  const addPackageTest = () => {
    setPackageForm({
      ...packageForm,
      includedTests: [...packageForm.includedTests, { name: "", subTestCount: 0, subTests: [""] }]
    });
  };

  const removePackageTest = (index) => {
    const updatedTests = packageForm.includedTests.filter((_, i) => i !== index);
    setPackageForm({ ...packageForm, includedTests: updatedTests });
  };

  const addSubTest = (testIndex) => {
    const updatedTests = [...packageForm.includedTests];
    updatedTests[testIndex].subTests.push("");
    setPackageForm({ ...packageForm, includedTests: updatedTests });
  };

  const removeSubTest = (testIndex, subTestIndex) => {
    const updatedTests = [...packageForm.includedTests];
    updatedTests[testIndex].subTests = updatedTests[testIndex].subTests.filter((_, i) => i !== subTestIndex);
    setPackageForm({ ...packageForm, includedTests: updatedTests });
  };

  const handleUpdatePackage = async () => {
  try {
    const token = localStorage.getItem("authToken");

    const formattedTests = packageForm.includedTests.map((test) => ({
      name: test.name,
      subTestCount: test.subTestCount,
      subTests: test.subTests.filter((subTest) => subTest.trim() !== ""),
    }));

    const payload = {
      ...packageForm,
      includedTests: formattedTests,
      gender: packageForm.gender,
    };

    const res = await axios.put(
      `${API_BASE}/updatepackage`,
      {
        packageId: editingPackage._id,
        ...payload,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire("Success", "Package updated successfully", "success");
    setEditingPackage(null);

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Update package error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to update package", "error");
  }
};

  // Handle new package changes
  const handleNewPackageChange = (e) => {
    setNewPackageForm({
      ...newPackageForm,
      [e.target.name]: e.target.value
    });
  };

  const handleNewPackageTestChange = (index, field, value) => {
    const updatedTests = [...newPackageForm.includedTests];
    updatedTests[index][field] = field === "subTestCount" ? parseInt(value) || 0 : value;
    setNewPackageForm({ ...newPackageForm, includedTests: updatedTests });
  };

  const handleNewPackageSubTestChange = (testIndex, subTestIndex, value) => {
    const updatedTests = [...newPackageForm.includedTests];
    updatedTests[testIndex].subTests[subTestIndex] = value;
    setNewPackageForm({ ...newPackageForm, includedTests: updatedTests });
  };

  const addNewPackageTest = () => {
    setNewPackageForm({
      ...newPackageForm,
      includedTests: [...newPackageForm.includedTests, { name: "", subTestCount: 0, subTests: [""] }]
    });
  };

  const removeNewPackageTest = (index) => {
    const updatedTests = newPackageForm.includedTests.filter((_, i) => i !== index);
    setNewPackageForm({ ...newPackageForm, includedTests: updatedTests });
  };

  const addNewSubTest = (testIndex) => {
    const updatedTests = [...newPackageForm.includedTests];
    updatedTests[testIndex].subTests.push("");
    setNewPackageForm({ ...newPackageForm, includedTests: updatedTests });
  };

  const removeNewSubTest = (testIndex, subTestIndex) => {
    const updatedTests = [...newPackageForm.includedTests];
    updatedTests[testIndex].subTests = updatedTests[testIndex].subTests.filter((_, i) => i !== subTestIndex);
    setNewPackageForm({ ...newPackageForm, includedTests: updatedTests });
  };

  // Create new package - UPDATED WITH GENDER
  const handleCreatePackage = async () => {
  try {
    const token = localStorage.getItem("authToken");

    const formattedTests = newPackageForm.includedTests.map((test) => ({
      name: test.name,
      subTestCount: test.subTestCount,
      subTests: test.subTests.filter((subTest) => subTest.trim() !== ""),
    }));

    const payload = {
      ...newPackageForm,
      includedTests: formattedTests,
      gender: newPackageForm.gender,
      diagnosticIds: [diagnostic._id],
    };

    const res = await axios.post(
      `${API_BASE}/create-packages`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire("Success", "Package created successfully", "success");

    setNewPackageForm({
      name: "",
      price: "",
      totalTestsIncluded: "",
      description: "",
      precautions: "",
      gender: "Both",
      includedTests: [{ name: "", subTestCount: 0, subTests: [""] }],
    });

    setShowAddPackageModal(false);

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Create package error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to create package", "error");
  }
};

  const handleDeletePackage = async (packageId) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This package will be deleted!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (!result.isConfirmed) return;

  try {
    const token = localStorage.getItem("authToken");

    await axios.delete(`${API_BASE}/deletepackage`, {
      data: {
        packageId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    Swal.fire("Deleted!", "Package has been deleted.", "success");

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Delete package error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to delete package", "error");
  }
};

  // Scan CRUD Operations - UPDATED WITH GENDER
  const handleEditScan = (scan) => {
    setEditingScan(scan);
    setScanForm({
      title: scan.title || "",
      price: scan.price || "",
      preparation: scan.preparation || "",
      reportTime: scan.reportTime || "",
      image: scan.image || "",
      gender: scan.gender || "Both" // Added gender
    });
  };

  const handleUpdateScan = async () => {
  try {
    const token = localStorage.getItem("authToken");

    const payload = {
      scanId: editingScan._id,
      ...scanForm,
      gender: scanForm.gender,
    };

    const res = await axios.put(
      `${API_BASE}/updatescan`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire("Success", "Scan updated successfully", "success");
    setEditingScan(null);

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Update scan error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to update scan", "error");
  }
};

  // Add Scan Function - UPDATED WITH GENDER
  const handleCreateScan = async () => {
  try {
    const token = localStorage.getItem("authToken");
    const formData = new FormData();

    formData.append("title", newScanForm.title);
    formData.append("price", newScanForm.price);
    formData.append("preparation", newScanForm.preparation);
    formData.append("reportTime", newScanForm.reportTime);
    formData.append("category", newScanForm.category);
    formData.append("gender", newScanForm.gender);
    formData.append("diagnosticIds", JSON.stringify([diagnostic._id]));

    if (newScanForm.image) {
      formData.append("image", newScanForm.image);
    }

    const res = await axios.post(
      `${API_BASE}/create-scan`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    Swal.fire("Success", "Scan created successfully", "success");

    setNewScanForm({
      title: "",
      price: "",
      preparation: "",
      reportTime: "",
      category: "",
      gender: "Both",
      image: null,
    });

    setShowAddScanModal(false);

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Create scan error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to create scan", "error");
  }
};

  const handleDeleteScan = async (scanId) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This scan will be deleted!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (!result.isConfirmed) return;

  try {
    const token = localStorage.getItem("authToken");

    await axios.delete(`${API_BASE}/deletescan`, {
      data: {
        scanId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    Swal.fire("Deleted!", "Scan has been deleted.", "success");

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Delete scan error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to delete scan", "error");
  }
};

  // Contact CRUD Operations
  const handleEditContact = (contact) => {
    setEditingContact(contact);
    setContactForm({
      name: contact.name || "",
      designation: contact.designation || "",
      gender: contact.gender || "",
      contactEmail: contact.contactEmail || "",
      contactNumber: contact.contactNumber || ""
    });
  };

 const handleUpdateContact = async () => {
  try {
    const token = localStorage.getItem("authToken");

    const res = await axios.put(
      `${API_BASE}/updatecontact`,
      {
        contactId: editingContact._id,
        ...contactForm,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire("Success", "Contact updated successfully", "success");
    setEditingContact(null);

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Update contact error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to update contact", "error");
  }
};

  const handleDeleteContact = async (contactId) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This contact will be deleted!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (!result.isConfirmed) return;

  try {
    const token = localStorage.getItem("authToken");

    await axios.delete(`${API_BASE}/deletecontact`, {
      data: {
        contactId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    Swal.fire("Deleted!", "Contact has been deleted.", "success");

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Delete contact error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to delete contact", "error");
  }
};

  // Branch CRUD Operations - UPDATED WITH GENDER
  const handleEditBranch = (branch) => {
    setEditingBranch(branch);
    setBranchForm({
      branchName: branch.branchName || "",
      email: branch.email || "",
      phone: branch.phone || "",
      address: branch.address || "",
      locationUrl: branch.locationUrl || "",
      country: branch.country || "",
      state: branch.state || "",
      city: branch.city || "",
      pincode: branch.pincode || "",
      gender: branch.gender || "Both", // Added gender
      contactPersons: branch.contactPersons?.map(cp => ({
        name: cp.name || "",
        designation: cp.designation || "",
        gender: cp.gender || "",
        contactEmail: cp.contactEmail || "",
        contactNumber: cp.contactNumber || ""
      })) || [{ name: "", designation: "", gender: "", contactEmail: "", contactNumber: "" }]
    });
  };

  const handleBranchContactChange = (index, field, value) => {
    const updatedContacts = [...branchForm.contactPersons];
    updatedContacts[index][field] = value;
    setBranchForm({ ...branchForm, contactPersons: updatedContacts });
  };

  const handleAddBranchContact = () => {
    setBranchForm({
      ...branchForm,
      contactPersons: [
        ...branchForm.contactPersons,
        { name: "", designation: "", gender: "", contactEmail: "", contactNumber: "" }
      ]
    });
  };

  const handleRemoveBranchContact = (index) => {
    if (branchForm.contactPersons.length > 1) {
      const updatedContacts = branchForm.contactPersons.filter((_, i) => i !== index);
      setBranchForm({ ...branchForm, contactPersons: updatedContacts });
    }
  };

  const handleCreateOrUpdateBranch = async () => {
  try {
    const token = localStorage.getItem("authToken");

    const payload = {
      ...branchForm,
      gender: branchForm.gender,
      diagnosticId: diagnostic._id,
    };

    let res;

    if (editingBranch) {
      res = await axios.put(
        `${API_BASE}/update-branch`,
        {
          branchId: editingBranch._id,
          ...payload,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.fire("Success", "Branch updated successfully", "success");
    } else {
      res = await axios.post(
        `${API_BASE}/add-branch`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.fire("Success", "Branch added successfully", "success");
    }

    setShowAddBranchModal(false);
    setEditingBranch(null);

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Branch operation error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to save branch", "error");
  }
};

  const handleDeleteBranch = async (branchId) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This branch will be deleted!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (!result.isConfirmed) return;

  try {
    const token = localStorage.getItem("authToken");

    await axios.delete(`${API_BASE}/delete-branch`, {
      data: {
        branchId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    Swal.fire("Deleted!", "Branch has been deleted.", "success");

    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(response.data.diagnostic);
  } catch (err) {
    console.error(
      "Delete branch error:",
      err.response?.data || err.message
    );

    Swal.fire("Error", "Failed to delete branch", "error");
  }
};

  // Bulk upload functions
  const handleBulkTestUpload = async (e, diagnosticId) => {
  const file = e.target.files[0];

  if (!file) {
    Swal.fire("Error", "Please select a CSV file", "error");
    return;
  }

  const token = localStorage.getItem("authToken");
  const formData = new FormData();

  formData.append("file", file);
  formData.append("diagnosticId", diagnosticId);

  try {
    const response = await fetch(`${API_BASE}/upload-testcsv`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Upload failed");
    }

    const result = await response.json();

    Swal.fire(
      "Success",
      `${result.insertedCount} tests uploaded successfully!`,
      "success"
    );

    const diagnosticResponse = await axios.post(
      `${API_BASE}/diagnostics`,
      { id: diagnosticId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(diagnosticResponse.data.diagnostic);
  } catch (error) {
    console.error("Bulk test upload error:", error);
    Swal.fire("Error", "Failed to upload CSV", "error");
  } finally {
    e.target.value = "";
  }
};

  const handleBulkUploadPackages = async (e, diagnosticId) => {
  const file = e.target.files[0];

  if (!file) {
    Swal.fire("Error", "Please select a CSV file", "error");
    return;
  }

  const token = localStorage.getItem("authToken");
  const formData = new FormData();

  formData.append("file", file);
  formData.append("diagnosticId", diagnosticId);

  try {
    const response = await axios.post(
      `${API_BASE}/upload-pkgcsv`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    Swal.fire("Success", "Packages uploaded successfully!", "success");

    const diagnosticResponse = await axios.post(
      `${API_BASE}/diagnostics`,
      { id: diagnosticId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(diagnosticResponse.data.diagnostic);
  } catch (error) {
    console.error(
      "Bulk package upload error:",
      error.response?.data || error.message
    );

    Swal.fire("Error", "Failed to upload CSV", "error");
  } finally {
    e.target.value = "";
  }
};

  const handleBulkUploadScans = async (e, diagnosticId) => {
  const file = e.target.files[0];

  if (!file) return;

  const token = localStorage.getItem("authToken");
  const formData = new FormData();

  formData.append("file", file);
  formData.append("diagnosticId", diagnosticId);

  try {
    const response = await fetch(`${API_BASE}/upload-xray-csv`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Failed to upload CSV");
    }

    const result = await response.json();

    Swal.fire(
      "Success",
      `${result.insertedCount} scans uploaded successfully!`,
      "success"
    );

    const diagnosticResponse = await axios.post(
      `${API_BASE}/diagnostics`,
      { id: diagnosticId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setDiagnostic(diagnosticResponse.data.diagnostic);
  } catch (error) {
    console.error("CSV upload error:", error);

    Swal.fire("Error", "Failed to upload scans CSV", "error");
  } finally {
    e.target.value = "";
  }
};


  // Add these states at the top with other states
const [multipleSlots, setMultipleSlots] = useState([
  { day: "", date: "", timeSlot: "", slotType: "home", gender: "Both" }
]);

// Add these functions

// Add a new empty slot to multiple slots form
const addMultipleSlot = () => {
  setMultipleSlots([
    ...multipleSlots,
    { day: "", date: "", timeSlot: "", slotType: "home", gender: "Both" }
  ]);
};

// Remove a slot from multiple slots
const removeMultipleSlot = (index) => {
  const updatedSlots = multipleSlots.filter((_, i) => i !== index);
  setMultipleSlots(updatedSlots);
};

// Update a specific slot in multiple slots
const updateMultipleSlot = (index, field, value) => {
  const updatedSlots = [...multipleSlots];
  updatedSlots[index][field] = value;
  setMultipleSlots(updatedSlots);
};

// Clear all multiple slots
const clearMultipleSlots = () => {
  setMultipleSlots([{ day: "", date: "", timeSlot: "", slotType: "home", gender: "Both" }]);
};

// Add multiple slots at once
const addBulkSlots = async () => {
  // Validate all slots
  const invalidSlots = multipleSlots.filter(
    (slot) => !slot.day || !slot.date || !slot.timeSlot || !slot.slotType
  );

  if (invalidSlots.length > 0) {
    Swal.fire({
      title: "Invalid Slots",
      text: "Please fill all fields in all slots",
      icon: "warning",
      confirmButtonText: "OK",
    });
    return;
  }

  try {
    const token = localStorage.getItem("authToken");

    const response = await axios.post(
      `${API_BASE}/add-multiple-slots`,
      {
        diagnosticId: diagnostic._id,
        slots: multipleSlots,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.success) {
      const { added, duplicates, errors } = response.data.summary;

      Swal.fire({
        title: "Success!",
        html: `
          <div class="text-left">
            <p><strong>Slots added successfully!</strong></p>
            <div class="mt-2 space-y-1">
              <p>✅ Added: ${added} slots</p>
              <p>⚠️ Duplicates skipped: ${duplicates}</p>
              ${errors > 0 ? `<p>❌ Errors: ${errors}</p>` : ""}
            </div>
          </div>
        `,
        icon: "success",
        confirmButtonText: "OK",
      });

      // Clear form
      setMultipleSlots([
        {
          day: "",
          date: "",
          timeSlot: "",
          slotType: "home",
          gender: "Both",
        },
      ]);

      // Refresh diagnostic data
      const diagnosticResponse = await axios.post(
        `${API_BASE}/diagnostics`,
        { id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setDiagnostic(diagnosticResponse.data.diagnostic);
    } else {
      throw new Error(response.data.message || "Failed to add slots");
    }
  } catch (error) {
    console.error(
      "Error adding multiple slots:",
      error.response?.data || error.message
    );

    Swal.fire({
      title: "Error!",
      text: error.response?.data?.message || "Failed to add slots",
      icon: "error",
      confirmButtonText: "OK",
    });
  }
};

// Quick add weekly slots
const addWeeklySlots = (type) => {
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const today = new Date();
  const newSlots = [];
  
  days.forEach(day => {
    // Add slots at 9 AM, 11 AM, 2 PM, 4 PM
    const times = ['09:00', '11:00', '14:00', '16:00'];
    
    times.forEach(time => {
      const slotDate = new Date(today);
      // Calculate next occurrence of this day
      const dayIndex = days.indexOf(day);
      const currentDayIndex = today.getDay();
      const daysToAdd = (dayIndex - currentDayIndex + 7) % 7 || 7;
      slotDate.setDate(today.getDate() + daysToAdd);
      
      newSlots.push({
        day: day,
        date: slotDate.toISOString().split('T')[0],
        timeSlot: time,
        slotType: type,
        gender: "Both"
      });
    });
  });
  
  setMultipleSlots([...multipleSlots, ...newSlots]);
};

// Quick add time range slots
const addTimeRangeSlots = (type) => {
  const { value: startTime } = prompt('Enter start time (HH:MM):', '09:00');
  const { value: endTime } = prompt('Enter end time (HH:MM):', '17:00');
  const { value: interval } = prompt('Enter interval in minutes:', '60');
  
  if (!startTime || !endTime || !interval) return;
  
  // Parse times
  const [startHour, startMinute] = startTime.split(':').map(Number);
  const [endHour, endMinute] = endTime.split(':').map(Number);
  
  const startDate = new Date();
  startDate.setHours(startHour, startMinute, 0, 0);
  const endDate = new Date();
  endDate.setHours(endHour, endMinute, 0, 0);
  
  const intervalMs = parseInt(interval) * 60000;
  const newSlots = [];
  let currentTime = startDate;
  
  while (currentTime <= endDate) {
    const hours = currentTime.getHours().toString().padStart(2, '0');
    const minutes = currentTime.getMinutes().toString().padStart(2, '0');
    const timeSlot = `${hours}:${minutes}`;
    
    // Add for next 7 days
    for (let i = 0; i < 7; i++) {
      const slotDate = new Date();
      slotDate.setDate(slotDate.getDate() + i);
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const dayName = days[slotDate.getDay()];
      
      newSlots.push({
        day: dayName,
        date: slotDate.toISOString().split('T')[0],
        timeSlot: timeSlot,
        slotType: type,
        gender: "Both"
      });
    }
    
    currentTime = new Date(currentTime.getTime() + intervalMs);
  }
  
  setMultipleSlots([...multipleSlots, ...newSlots]);
};

  const downloadCSVTemplate = () => {
    const headers = [
      "name",
      "description",
      "price",
      "reportIn24Hrs",
      "reportHour",
      "instruction",
      "fastingRequired",
      "homeCollectionAvailable",
      "category",
      "precaution",
      "gender", // Added gender
      "image"
    ];

    const sample = [
      "Blood Sugar",
      "Test for blood glucose levels",
      "300",
      "true",
      "24",
      "Fast for 8 hours before test",
      "true",
      "true",
      "General",
      "Avoid alcohol 24 hrs before test",
      "Both", // Added gender sample
      "https://example.com/image.jpg"
    ];

    const csvContent = [headers.join(","), sample.join(",")].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "test-upload-template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadPackageCSVTemplate = () => {
    const headers = [
      "packageName",
      "price", 
      "totalTestsIncluded",
      "description",
      "precautions",
      "gender", // Added gender
      "testName",
      "subTests"
    ];

    const rows = [
      ["Blood Package", "5000", "3", "Comprehensive blood test package", "Fast for 8 hours", "Both", "Complete Blood Count", "Hemoglobin,RBC,WBC"],
      ["Blood Package", "5000", "3", "Comprehensive blood test package", "Fast for 8 hours", "Both", "Liver Function Test", "SGOT,SGPT"],
      ["Blood Package", "5000", "3", "Comprehensive blood test package", "Fast for 8 hours", "Both", "Kidney Function Test", "Creatinine,Urea"]
    ];

    const csvContent = [
      headers.join(","),
      ...rows.map(row => row.join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "package-template.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadScanCSVTemplate = () => {
    const headers = ["title", "price", "preparation", "reportTime", "gender", "image"]; // Added gender
    const exampleRow = [
      "Chest X-ray",
      1000,
      "No preparation needed",
      "24 Hours",
      "Both", // Added gender
      "https://example.com/images/chest-xray.jpg"
    ];

    const csvContent = [
      headers.join(","),
      exampleRow.map(val => `"${String(val).replace(/"/g, '""')}"`).join(",")
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "scan-xray-template.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) return <div className="p-4">Loading...</div>;
  if (error) return <div className="p-4 text-red-500">{error}</div>;
  if (!diagnostic) return <div className="p-4">Diagnostic center not found</div>;


  // Bulk update slots function
const handleBulkUpdateSlots = async () => {
  const {
    slotType,
    startDate,
    endDate,
    startTime,
    endTime,
    timeGap,
    operation,
  } = bulkUpdateForm;

  if (!startDate || !endDate || !startTime || !endTime) {
    Swal.fire("Error", "Please fill all required fields", "warning");
    return;
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (start > end) {
    Swal.fire("Error", "End date must be after start date", "warning");
    return;
  }

  const token = localStorage.getItem("authToken");
  const diagnosticId = diagnostic._id;

  const authConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  const refreshDiagnostic = async () => {
    const response = await axios.post(
      `${API_BASE}/diagnostics`,
      { id },
      authConfig
    );

    setDiagnostic(response.data.diagnostic);
  };

  const calculateSlotsPerDay = () => {
    const [startHour, startMinute] = startTime.split(":").map(Number);
    const [endHour, endMinute] = endTime.split(":").map(Number);

    let currentHour = startHour;
    let currentMinute = startMinute;
    let count = 0;
    const gap = parseInt(timeGap, 10);

    if (!Number.isFinite(gap) || gap <= 0) return 0;

    while (
      currentHour < endHour ||
      (currentHour === endHour && currentMinute <= endMinute)
    ) {
      count++;
      currentMinute += gap;

      if (currentMinute >= 60) {
        currentHour += Math.floor(currentMinute / 60);
        currentMinute %= 60;
      }
    }

    return count;
  };

  const slotsPerDay = calculateSlotsPerDay();
  const days = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
  const totalNewSlots = days * slotsPerDay;

  const slotArray =
    slotType === "home"
      ? diagnostic.homeCollectionSlots
      : diagnostic.centerVisitSlots;

  const slotsToDelete = [];

  slotArray.forEach((slot) => {
    const slotDate = new Date(slot.date);
    slotDate.setHours(0, 0, 0, 0);

    const rangeStart = new Date(start);
    rangeStart.setHours(0, 0, 0, 0);

    const rangeEnd = new Date(end);
    rangeEnd.setHours(23, 59, 59, 999);

    if (slotDate >= rangeStart && slotDate <= rangeEnd) {
      if (slot.timeSlot >= startTime && slot.timeSlot <= endTime) {
        slotsToDelete.push({
          slotId: slot._id,
          day: slot.day,
          date: slot.date,
          timeSlot: slot.timeSlot,
        });
      }
    }
  });

  // REPLACE OPERATION
  if (operation === "replace") {
    if (slotsPerDay === 0) {
      Swal.fire(
        "Error",
        "No time slots will be created with the given time range and gap",
        "warning"
      );
      return;
    }

    const confirmResult = await Swal.fire({
      title: "⚠️ Replace All Slots",
      html: `
        <div class="text-left">
          <p><b>This action will:</b></p>
          <ul class="text-sm list-disc pl-4 mb-3">
            <li>Delete ${slotsToDelete.length} existing slots from ${startDate} to ${endDate}</li>
            <li>Create ${slotsPerDay} new slots per day</li>
            <li>Total ${totalNewSlots} new slots will be created</li>
          </ul>
          <p class="text-red-600 text-sm"><b>This cannot be undone!</b></p>
        </div>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Replace All",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    });

    if (!confirmResult.isConfirmed) return;

    try {
      const response = await axios.put(
        `${API_BASE}/update-slot`,
        {
          diagnosticId,
          slotType,
          bulkOperation: "replace",
          bulkData: {
            startDate,
            endDate,
            startTime,
            endTime,
            timeGap: parseInt(timeGap, 10),
          },
        },
        authConfig
      );

      const summary = response.data.summary;

      Swal.fire({
        title: "✅ Success!",
        html: `
          <div class="text-left">
            <p><b>Slots Replaced Successfully</b></p>
            <div class="mt-2 space-y-1 text-sm">
              <p><b>Dates Updated:</b> ${summary.datesUpdated} days</p>
              <p><b>Slots Removed:</b> ${summary.slotsRemoved}</p>
              <p><b>Slots Added:</b> ${summary.slotsAdded}</p>
              <p><b>Total Slots Now:</b> ${summary.totalSlotsNow}</p>
              <p><b>New Time Pattern:</b> ${summary.newTimePattern.join(", ")}</p>
            </div>
          </div>
        `,
        icon: "success",
        confirmButtonText: "OK",
      });

      await refreshDiagnostic();

      setBulkUpdateForm({
        slotType: "home",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        timeGap: 30,
        operation: "replace",
      });
    } catch (err) {
      console.error(
        "Bulk replace error:",
        err.response?.data || err.message
      );

      Swal.fire(
        "Error!",
        err.response?.data?.message || "Failed to replace slots",
        "error"
      );
    }

    return;
  }

  // UPDATE OPERATION
  if (operation === "update") {
    const slotsToUpdate = [];

    slotArray.forEach((slot) => {
      const slotDate = new Date(slot.date);
      slotDate.setHours(0, 0, 0, 0);

      const rangeStart = new Date(start);
      rangeStart.setHours(0, 0, 0, 0);

      const rangeEnd = new Date(end);
      rangeEnd.setHours(0, 0, 0, 0);

      if (
        slotDate >= rangeStart &&
        slotDate <= rangeEnd &&
        slot.timeSlot >= startTime &&
        slot.timeSlot <= endTime
      ) {
        slotsToUpdate.push({
          slotId: slot._id,
          currentDay: slot.day,
          currentDate: slot.date,
          currentTimeSlot: slot.timeSlot,
        });
      }
    });

    if (slotsToUpdate.length === 0) {
      Swal.fire(
        "Info",
        "No slots found to update in the selected range",
        "info"
      );
      return;
    }

    const generatedSlots = generateTimeSlotsWithGap(
      startTime,
      endTime,
      timeGap
    );

    if (!generatedSlots.length) {
      Swal.fire(
        "Error",
        "No time slots generated with the given gap",
        "warning"
      );
      return;
    }

    const confirmResult = await Swal.fire({
      title: "Update Time Slots",
      html: `
        <div class="text-left">
          <p><b>You are about to update ${slotsToUpdate.length} slots</b></p>
          <p><b>Date Range:</b> ${startDate} to ${endDate}</p>
          <p><b>Time Range:</b> ${startTime} to ${endTime}</p>
          <p><b>New Time Slots:</b> ${generatedSlots.join(", ")}</p>
          <p class="text-sm text-gray-600 mt-2">
            This will update the time of existing slots only. No slots will be deleted.
          </p>
        </div>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, Update Times",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) return;

    try {
      const updatePromises = slotsToUpdate.map((slot, index) =>
        axios.put(
          `${API_BASE}/update-slot`,
          {
            diagnosticId,
            slotType: slotType === "home" ? "home" : "center",
            slotId: slot.slotId,
            newSlot: {
              newDay: slot.currentDay,
              newDate: slot.currentDate,
              newTimeSlot: generatedSlots[index % generatedSlots.length],
              isBooked: false,
            },
          },
          authConfig
        )
      );

      await Promise.all(updatePromises);

      Swal.fire(
        "Success",
        `${slotsToUpdate.length} slots updated successfully`,
        "success"
      );

      await refreshDiagnostic();

      setBulkUpdateForm({
        slotType: "home",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        timeGap: 30,
        operation: "update",
      });
    } catch (err) {
      console.error(
        "Bulk update error:",
        err.response?.data || err.message
      );

      Swal.fire("Error", "Failed to update slots", "error");
    }

    return;
  }

  // DELETE OPERATION
  if (operation === "delete") {
    if (slotsToDelete.length === 0) {
      Swal.fire(
        "Info",
        "No slots found to delete in the selected range",
        "info"
      );
      return;
    }

    const confirmResult = await Swal.fire({
      title: "Confirm Delete",
      html: `Are you sure you want to delete <b>${slotsToDelete.length} slots</b>?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete them!",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) return;

    try {
      const deletePromises = slotsToDelete.map((slot) =>
        axios.put(
          `${API_BASE}/delete-diagslot`,
          {
            diagnosticId,
            slotType: slotType === "home" ? "home" : "center",
            day: slot.day,
            date: slot.date,
            timeSlot: slot.timeSlot,
          },
          authConfig
        )
      );

      await Promise.all(deletePromises);

      Swal.fire(
        "Deleted",
        `${slotsToDelete.length} slots deleted successfully`,
        "success"
      );

      await refreshDiagnostic();

      setBulkUpdateForm({
        slotType: "home",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        timeGap: 30,
        operation: "delete",
      });
    } catch (err) {
      console.error(
        "Delete error:",
        err.response?.data || err.message
      );

      Swal.fire("Error", "Failed to delete slots", "error");
    }
  }
};

// Helper function to generate time slots with gap
const generateTimeSlotsWithGap = (startTime, endTime, gapMinutes) => {
  const slots = [];
  const [startHour, startMinute] = startTime.split(':').map(Number);
  const [endHour, endMinute] = endTime.split(':').map(Number);
  
  let currentHour = startHour;
  let currentMinute = startMinute;
  
  while (currentHour < endHour || (currentHour === endHour && currentMinute <= endMinute)) {
    const timeStr = `${currentHour.toString().padStart(2, '0')}:${currentMinute.toString().padStart(2, '0')}`;
    slots.push(timeStr);
    
    // Add gap
    currentMinute += gapMinutes;
    if (currentMinute >= 60) {
      currentHour += Math.floor(currentMinute / 60);
      currentMinute = currentMinute % 60;
    }
  }
  
  return slots;
};

// // Helper function to generate time slots with gap
// const generateTimeSlotsWithGap = (startTime, endTime, gapMinutes) => {
//   const slots = [];
//   const [startHour, startMinute] = startTime.split(':').map(Number);
//   const [endHour, endMinute] = endTime.split(':').map(Number);
  
//   let currentHour = startHour;
//   let currentMinute = startMinute;
  
//   while (currentHour < endHour || (currentHour === endHour && currentMinute <= endMinute)) {
//     const timeStr = `${currentHour.toString().padStart(2, '0')}:${currentMinute.toString().padStart(2, '0')}`;
//     slots.push(timeStr);
    
//     // Add gap
//     currentMinute += gapMinutes;
//     if (currentMinute >= 60) {
//       currentHour += Math.floor(currentMinute / 60);
//       currentMinute = currentMinute % 60;
//     }
//   }
  
//   return slots;
// };


// Preview bulk operation
const previewBulkOperation = () => {
  const { slotType, startDate, endDate, startTime, endTime, operation } = bulkUpdateForm;
  
  const slotArray = slotType === "home" 
    ? diagnostic.homeCollectionSlots 
    : diagnostic.centerVisitSlots;
    
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  const affectedSlots = slotArray.filter(slot => {
    const slotDate = new Date(slot.date);
    return slotDate >= start && slotDate <= end && 
           (!startTime || slot.timeSlot >= startTime) && 
           (!endTime || slot.timeSlot <= endTime);
  });
  
  Swal.fire({
    title: `Preview ${operation === "update" ? "Update" : "Delete"}`,
    html: `
      <div class="text-left">
        <p><strong>Slot Type:</strong> ${slotType === "home" ? "Home Collection" : "Center Visit"}</p>
        <p><strong>Date Range:</strong> ${startDate} to ${endDate}</p>
        <p><strong>Time Range:</strong> ${startTime || 'Any'} to ${endTime || 'Any'}</p>
        <p><strong>Total Slots Found:</strong> ${affectedSlots.length}</p>
        <div class="mt-3 max-h-60 overflow-y-auto">
          ${affectedSlots.slice(0, 10).map(slot => `
            <div class="border-b py-1">
              ${slot.date} | ${slot.timeSlot} | ${slot.day}
            </div>
          `).join('')}
          ${affectedSlots.length > 10 ? `<p class="text-sm text-gray-500">... and ${affectedSlots.length - 10} more</p>` : ''}
        </div>
      </div>
    `,
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: 'Proceed',
    cancelButtonText: 'Cancel'
  }).then((result) => {
    if (result.isConfirmed) {
      handleBulkUpdateSlots();
    }
  });
};

  return (
    <div className="p-4 bg-white rounded shadow">
      <div className="flex items-start mb-6">
        {diagnostic.image && (
          <div className="mr-6">
            <img
              src={`${BASE_URL}${diagnostic.image}`}
              alt={diagnostic.name}
              className="w-32 h-32 object-cover rounded border"
            />
          </div>
        )}
        <div>
          <h1 className="text-2xl font-bold">{diagnostic.name}</h1>
          <p className="text-gray-600">{diagnostic.centerType} Center</p>
          <p className="text-gray-600">{diagnostic.methodology} Services</p>
          {diagnostic.pathologyAccredited && (
            <p className="text-gray-600">Accreditation: {diagnostic.pathologyAccredited}</p>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div className="flex border-b mb-6 overflow-x-auto">
        {[
          { id: "basic", label: "Basic Info" },
          { id: "tests", label: `Tests (${diagnostic.tests.length})` },
          { id: "packages", label: `Packages (${diagnostic.packages.length})` },
          { id: "scans", label: `Scans (${diagnostic.scans.length})` },
          { id: "slots", label: "Slots" },
          { id: "contacts", label: `Contacts (${diagnostic.contactPersons.length})` },
          { id: "branches", label: `Branches (${diagnostic.branches?.length || 0})` }
        ].map(tab => (
          <button
            key={tab.id}
            className={`py-2 px-4 whitespace-nowrap ${activeTab === tab.id ? "border-b-2 border-blue-500 font-medium" : "text-gray-600"}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "basic" && (
          <div className="space-y-6">
            <h2 className="text-xl font-semibold">Basic Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gray-50 p-4 rounded">
                <h3 className="font-medium text-lg mb-3 text-gray-800">Contact Information</h3>
                <div className="space-y-2">
                  <p><span className="font-medium">Email:</span> {diagnostic.email}</p>
                  <p><span className="font-medium">Password:</span> {diagnostic.password}</p>
                  <p><span className="font-medium">Phone:</span> {diagnostic.phone}</p>
                  <p><span className="font-medium">Address:</span> {diagnostic.address}</p>
                </div>
              </div>

              <div className="bg-gray-50 p-4 rounded">
                <h3 className="font-medium text-lg mb-3 text-gray-800">Center Details</h3>
                <div className="space-y-2">
                  <p><span className="font-medium">Type:</span> {diagnostic.centerType}</p>
                  <p><span className="font-medium">Methodology:</span> {diagnostic.methodology}</p>
                  <p><span className="font-medium">Network:</span> {diagnostic.network}</p>
                  <p><span className="font-medium">Description:</span> {diagnostic.description}</p>
                  <p><span className="font-medium">Accreditation:</span> {diagnostic.pathologyAccredited || "None"}</p>
                </div>
              </div>

              <div className="bg-gray-50 p-4 rounded">
                <h3 className="font-medium text-lg mb-3 text-gray-800">Location</h3>
                <div className="space-y-2">
                  <p><span className="font-medium">Country:</span> {diagnostic.country}</p>
                  <p><span className="font-medium">State:</span> {diagnostic.state}</p>
                  <p><span className="font-medium">City:</span> {diagnostic.city}</p>
                  <p><span className="font-medium">Pincode:</span> {diagnostic.pincode}</p>
                </div>
              </div>

              <div className="bg-gray-50 p-4 rounded">
                <h3 className="font-medium text-lg mb-3 text-gray-800">Visit Options</h3>
                <div className="space-y-2">
                  <p><span className="font-medium">Visit Type:</span> {diagnostic.visitType}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "tests" && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold">Available Tests</h2>
              <div className="flex gap-2">
                 <button
                  onClick={() => setShowAddTestModal(true)}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                >
                  <FiPlus className="w-5 h-5" />
                  <span className="text-sm">Add Test</span>
                </button>
                <label className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm cursor-pointer hover:bg-gray-50 transition">
                  <FiUploadCloud className="w-5 h-5 text-gray-500" />
                  <span className="text-sm text-gray-700">Upload CSV</span>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => handleBulkTestUpload(e, diagnostic._id)}
                    className="hidden"
                  />
                </label>
                <button
                  onClick={downloadCSVTemplate}
                  className="inline-flex items-center gap-2 px-3 py-2 border rounded hover:bg-gray-50"
                >
                  <FiDownload className="text-gray-500" />
                  <span className="text-sm">Download CSV Format</span>
                </button>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg overflow-hidden">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="py-3 px-4 text-left font-medium">Test Name</th>
                    <th className="py-3 px-4 text-left font-medium">MRP (₹)</th>
                    <th className="py-3 px-4 text-left font-medium">Gender</th> {/* Added column */}
                    <th className="py-3 px-4 text-left font-medium">Fasting</th>
                    <th className="py-3 px-4 text-left font-medium">Home Collection</th>
                    <th className="py-3 px-4 text-left font-medium">Report Time</th>
                    <th className="py-3 px-4 text-left font-medium">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {diagnostic.tests.map((test) => (
                    <tr key={test._id} className="hover:bg-gray-50">
                      <td className="py-3 px-4">{test.name}</td>
                      <td className="py-3 px-4">{test.price}</td>
                      <td className="py-3 px-4">
                        <span className="px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800 capitalize">
                          {test.gender || 'Both'}
                        </span>
                      </td>
                      <td className="py-3 px-4">
                        <span className={`px-2 py-1 rounded-full text-xs ${test.fastingRequired ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
                          {test.fastingRequired ? 'Required' : 'Not Required'}
                        </span>
                      </td>
                      <td className="py-3 px-4">
                        <span className={`px-2 py-1 rounded-full text-xs ${test.homeCollectionAvailable ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
                          {test.homeCollectionAvailable ? 'Available' : 'Not Available'}
                        </span>
                      </td>
                      <td className="py-3 px-4">
                        {test.reportIn24Hrs ? '24 Hours' : `${test.reportHour || '48'} Hours`}
                      </td>
                      <td className="py-3 px-4">
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleEditTest(test)}
                            className="text-blue-600 hover:text-blue-800"
                            title="Edit"
                          >
                            <FiEdit className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleDeleteTest(test._id)}
                            className="text-red-600 hover:text-red-800"
                            title="Delete"
                          >
                            <FiTrash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab === "packages" && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold">Health Packages</h2>
              <div className="flex gap-2">
                  <button
          onClick={() => setShowAddPackageModal(true)}
          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
        >
          <FiPlus className="w-5 h-5" />
          <span className="text-sm">Add Package</span>
        </button>
                <label className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm cursor-pointer hover:bg-gray-50 transition">
                  <FiUploadCloud className="w-5 h-5" />
                  <span className="text-sm">Bulk Upload</span>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => handleBulkUploadPackages(e, diagnostic._id)}
                    className="hidden"
                  />
                </label>
                <button
                  onClick={downloadPackageCSVTemplate}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition"
                >
                  <FiDownload className="w-5 h-5" />
                  <span className="text-sm">Download CSV Template</span>
                </button>
              </div>
            </div>

            <div className="grid gap-6">
              {diagnostic.packages.map((pkg) => (
                <div key={pkg._id} className="border rounded-lg overflow-hidden">
                  <div className="bg-gray-100 p-4 flex justify-between items-center">
                    <div>
                      <h3 className="font-semibold text-lg">{pkg.name}</h3>
                      <div className="flex items-center gap-2">
                        <p className="text-gray-600">₹{pkg.price} • {pkg.totalTestsIncluded} tests included</p>
                        <span className="px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800 capitalize">
                          {pkg.gender || 'Both'}
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEditPackage(pkg)}
                        className="text-blue-600 hover:text-blue-800"
                        title="Edit"
                      >
                        <FiEdit className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => handleDeletePackage(pkg._id)}
                        className="text-red-600 hover:text-red-800"
                        title="Delete"
                      >
                        <FiTrash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>

                  <div className="p-4">
                    <div className="mb-4">
                      <h4 className="font-medium mb-2">Description</h4>
                      <p className="text-gray-700">{pkg.description || 'No description provided'}</p>
                    </div>

                    {pkg.precautions && (
                      <div className="mb-4">
                        <h4 className="font-medium mb-2">Precautions</h4>
                        <p className="text-gray-700">{pkg.precautions}</p>
                      </div>
                    )}

                    <div>
                      <h4 className="font-medium mb-2">Included Tests</h4>
                      <div className="space-y-3">
                        {pkg.includedTests.map((test, index) => (
                          <div key={index} className="border-l-4 border-blue-500 pl-3 py-1">
                            <p className="font-medium">{test.name}</p>
                            <p className="text-sm text-gray-600">
                              Includes {test.subTestCount} sub-tests: {test.subTests.join(', ')}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === "scans" && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold">Scans & X-Rays</h2>
              <div className="flex gap-2">
                  <button
                  onClick={() => setShowAddScanModal(true)}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                >
                  <FiPlus className="w-5 h-5" />
                  <span className="text-sm">Add Scan</span>
                </button>
                <label className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm cursor-pointer hover:bg-gray-50 transition">
                  <FiUploadCloud className="w-5 h-5 text-gray-600" />
                  <span className="text-sm text-gray-700">Bulk Upload</span>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => handleBulkUploadScans(e, diagnostic._id)}
                    className="hidden"
                  />
                </label>
                <button
                  onClick={downloadScanCSVTemplate}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm cursor-pointer hover:bg-gray-50 transition"
                >
                  <FiDownload className="w-5 h-5" />
                  <span className="text-sm">Download CSV Template</span>
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {diagnostic.scans.map((scan) => (
                <div key={scan._id} className="border rounded-lg overflow-hidden hover:shadow-md transition-shadow">
                  {scan.image && (
                    <img
                      src={`https://api.elthiumhealth.com${scan.image}`}
                      alt={scan.title}
                      className="w-full h-48 object-cover"
                    />
                  )}
                  <div className="bg-gray-100 p-4 flex justify-between items-center">
                    <div>
                      <div className="flex items-center gap-2">
                        <h3 className="font-semibold text-lg">{scan.title}</h3>
                        <span className="px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800 capitalize">
                          {scan.gender || 'Both'}
                        </span>
                      </div>
                      <span className="font-medium text-blue-600">₹{scan.price}</span>
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEditScan(scan)}
                        className="text-blue-600 hover:text-blue-800"
                        title="Edit"
                      >
                        <FiEdit className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => handleDeleteScan(scan._id)}
                        className="text-red-600 hover:text-red-800"
                        title="Delete"
                      >
                        <FiTrash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>

                  <div className="p-4">
                    <div className="mb-3">
                      <h4 className="font-medium text-sm text-gray-500">Preparation</h4>
                      <p className="text-gray-700">{scan.preparation || 'No special preparation required'}</p>
                    </div>
                    <div>
                      <h4 className="font-medium text-sm text-gray-500">Report Time</h4>
                      <p className="text-gray-700">{scan.reportTime || '24-48 hours'}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
{activeTab === "slots" && (
  <div className="space-y-8">
    <h2 className="text-xl font-semibold mb-6">Available Slots</h2>

    {/* Home and Center Slots Display */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Home Collection Slots */}
      <div className="border rounded-lg overflow-hidden">
        <div className="bg-gray-100 p-4 flex justify-between items-center">
          <h3 className="font-semibold text-lg">Home Collection Slots</h3>
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
            {diagnostic.homeCollectionSlots.length} slots
          </span>
        </div>
        <div className="p-4 space-y-4 max-h-96 overflow-y-auto">
          {diagnostic.homeCollectionSlots.length > 0 ? (
            diagnostic.homeCollectionSlots.map((slot, index) => (
              <div key={index} className="border rounded p-3 hover:bg-gray-50">
                <div className="flex justify-between items-start">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <p className="font-medium">{slot.day}</p>
                    </div>
                    <p className="text-sm text-gray-600">{slot.date}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-sm">
                      {slot.timeSlot}
                    </span>
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${slot.isBooked
                        ? "bg-red-100 text-red-700"
                        : "bg-green-100 text-green-700"
                        }`}
                    >
                      {slot.isBooked ? "Booked" : "Available"}
                    </span>
                    <button
                      className="text-blue-600 text-xs hover:text-blue-800"
                      onClick={() => handleEditSlot(slot, "home")}
                    >
                      Edit
                    </button>
                    <button
                      className="text-red-600 text-xs hover:text-red-800"
                      onClick={() => deleteSlot(slot, "home")}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-500">No home collection slots available</p>
            </div>
          )}
        </div>
      </div>

      {/* Center Visit Slots */}
      <div className="border rounded-lg overflow-hidden">
        <div className="bg-gray-100 p-4 flex justify-between items-center">
          <h3 className="font-semibold text-lg">Center Visit Slots</h3>
          <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">
            {diagnostic.centerVisitSlots.length} slots
          </span>
        </div>
        <div className="p-4 space-y-4 max-h-96 overflow-y-auto">
          {diagnostic.centerVisitSlots.length > 0 ? (
            diagnostic.centerVisitSlots.map((slot, index) => (
              <div key={index} className="border rounded p-3 hover:bg-gray-50">
                <div className="flex justify-between items-start">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <p className="font-medium">{slot.day}</p>
                    </div>
                    <p className="text-sm text-gray-600">{slot.date}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm">
                      {slot.timeSlot}
                    </span>
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${slot.isBooked
                        ? "bg-red-100 text-red-700"
                        : "bg-green-100 text-green-700"
                        }`}
                    >
                      {slot.isBooked ? "Booked" : "Available"}
                    </span>
                    <button
                      className="text-blue-600 text-xs hover:text-blue-800"
                      onClick={() => handleEditSlot(slot, "center")}
                    >
                      Edit
                    </button>
                    <button
                      className="text-red-600 text-xs hover:text-red-800"
                      onClick={() => deleteSlot(slot, "center")}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-500">No center visit slots available</p>
            </div>
          )}
        </div>
      </div>
    </div>

    {/* Bulk Update/Delete Slots Section */}
    <div className="mt-8 border p-4 rounded-lg bg-blue-50">
      <div className="flex items-center gap-2 mb-4">
        <FiRefreshCw className="w-5 h-5 text-blue-600" />
        <h3 className="text-lg font-semibold text-blue-800">Bulk Update/Delete Slots</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Slot Type */}
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Slot Type *</label>
          <select
            value={bulkUpdateForm.slotType}
            onChange={(e) => setBulkUpdateForm({...bulkUpdateForm, slotType: e.target.value})}
            className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="home">Home Collection</option>
            <option value="center">Center Visit</option>
          </select>
        </div>

        {/* Operation */}
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Operation *</label>
          <select
            value={bulkUpdateForm.operation}
            onChange={(e) => setBulkUpdateForm({...bulkUpdateForm, operation: e.target.value})}
            className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="update">Update Time Slots</option>
            <option value="delete">Delete Slots</option>
          </select>
        </div>

        {/* Time Gap (only for update) */}
        {bulkUpdateForm.operation === "update" && (
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Time Gap (min) *</label>
            <select
              value={bulkUpdateForm.timeGap}
              onChange={(e) => setBulkUpdateForm({...bulkUpdateForm, timeGap: parseInt(e.target.value)})}
              className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="15">15 minutes</option>
              <option value="30">30 minutes</option>
              <option value="45">45 minutes</option>
              <option value="60">1 hour</option>
              <option value="120">2 hours</option>
            </select>
          </div>
        )}
      </div>

      {/* Date Range */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Start Date *</label>
          <input
            type="date"
            value={bulkUpdateForm.startDate}
            onChange={(e) => setBulkUpdateForm({...bulkUpdateForm, startDate: e.target.value})}
            className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">End Date *</label>
          <input
            type="date"
            value={bulkUpdateForm.endDate}
            onChange={(e) => setBulkUpdateForm({...bulkUpdateForm, endDate: e.target.value})}
            className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      {/* Time Range - हर date के लिए same */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">Start Time *</label>
          <input
            type="time"
            value={bulkUpdateForm.startTime}
            onChange={(e) => setBulkUpdateForm({...bulkUpdateForm, startTime: e.target.value})}
            className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">End Time *</label>
          <input
            type="time"
            value={bulkUpdateForm.endTime}
            onChange={(e) => setBulkUpdateForm({...bulkUpdateForm, endTime: e.target.value})}
            className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      {/* Preview Section - अब हर date के slots अलग-अलग दिखाएगा */}
      {bulkUpdateForm.startDate && bulkUpdateForm.endDate && (
        <div className="mt-6 p-4 bg-white border rounded-lg">
          <div className="flex items-center gap-2 mb-3">
            <FiEye className="w-4 h-4 text-gray-600" />
            <h4 className="font-medium text-gray-700">Preview - Date Wise</h4>
          </div>
          
          {(() => {
            const slotArray = bulkUpdateForm.slotType === "home" 
              ? diagnostic.homeCollectionSlots 
              : diagnostic.centerVisitSlots;
            
            const start = new Date(bulkUpdateForm.startDate);
            const end = new Date(bulkUpdateForm.endDate);
            end.setHours(23, 59, 59, 999);
            
            // Get all dates in range
            const allDates = [];
            let currentDate = new Date(start);
            while (currentDate <= end) {
              const dateStr = currentDate.toISOString().split('T')[0];
              allDates.push(dateStr);
              currentDate.setDate(currentDate.getDate() + 1);
            }
            
            // Group slots by date
            const slotsByDate = {};
            allDates.forEach(date => {
              const slotsForDate = slotArray.filter(slot => slot.date === date);
              if (bulkUpdateForm.startTime && bulkUpdateForm.endTime) {
                slotsByDate[date] = slotsForDate.filter(slot => 
                  slot.timeSlot >= bulkUpdateForm.startTime && 
                  slot.timeSlot <= bulkUpdateForm.endTime
                );
              } else {
                slotsByDate[date] = slotsForDate;
              }
            });
            
            const totalSlots = Object.values(slotsByDate).flat().length;
            
            return (
              <div>
                <div className="mb-3">
                  <span className="text-sm text-gray-600">
                    <span className="font-medium">Total Dates:</span> {allDates.length} dates
                  </span>
                  <span className="mx-4">•</span>
                  <span className="text-sm text-gray-600">
                    <span className="font-medium">Total Slots:</span> {totalSlots} slots
                  </span>
                </div>
                
                {allDates.length > 0 && (
                  <div className="max-h-60 overflow-y-auto border rounded p-2">
                    {allDates.slice(0, 5).map((date, index) => {
                      const dayOfWeek = new Date(date).toLocaleDateString('en-US', { weekday: 'long' });
                      const slotsForDate = slotsByDate[date] || [];
                      
                      return (
                        <div key={index} className="mb-3 pb-3 border-b last:border-b-0 last:mb-0">
                          <div className="flex justify-between items-center mb-2">
                            <div>
                              <span className="font-medium">{date}</span>
                              <span className="mx-2 text-gray-400">•</span>
                              <span className="text-sm text-gray-600">{dayOfWeek}</span>
                            </div>
                            <span className="text-xs bg-gray-100 px-2 py-1 rounded">
                              {slotsForDate.length} slots
                            </span>
                          </div>
                          
                          {slotsForDate.length > 0 && (
                            <div className="flex flex-wrap gap-1">
                              {slotsForDate.slice(0, 6).map((slot, slotIndex) => (
                                <span key={slotIndex} className="text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded">
                                  {slot.timeSlot}
                                </span>
                              ))}
                              {slotsForDate.length > 6 && (
                                <span className="text-xs text-gray-500 px-2 py-1">
                                  +{slotsForDate.length - 6} more
                                </span>
                              )}
                            </div>
                          )}
                          
                          {slotsForDate.length === 0 && (
                            <div className="text-xs text-gray-500 italic">
                              No slots in selected time range
                            </div>
                          )}
                        </div>
                      );
                    })}
                    
                    {allDates.length > 5 && (
                      <div className="text-center py-2 text-sm text-gray-500">
                        ... and {allDates.length - 5} more dates
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      )}

      {/* Action Buttons */}
      <div className="mt-6 flex flex-wrap gap-3">
        <button
          onClick={previewBulkOperation}
          disabled={!bulkUpdateForm.startDate || !bulkUpdateForm.endDate}
          className="flex items-center gap-2 px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 disabled:opacity-50 disabled:cursor-not-allowed transition"
        >
          <FiEye className="w-4 h-4" />
          Preview Details
        </button>

        <button
          onClick={handleBulkUpdateSlots}
          disabled={!bulkUpdateForm.startDate || !bulkUpdateForm.endDate || !bulkUpdateForm.startTime || !bulkUpdateForm.endTime}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-white transition ${bulkUpdateForm.operation === "update" 
            ? "bg-blue-600 hover:bg-blue-700" 
            : "bg-red-600 hover:bg-red-700"
          } disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          {bulkUpdateForm.operation === "update" ? (
            <>
              <FiRefreshCw className="w-4 h-4" />
              Update Slots
            </>
          ) : (
            <>
              <FiTrash2 className="w-4 h-4" />
              Delete Slots
            </>
          )}
        </button>

        <button
          onClick={() => setBulkUpdateForm({
            slotType: "home",
            startDate: "",
            endDate: "",
            startTime: "",
            endTime: "",
            timeGap: 30,
            operation: "update"
          })}
          className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
        >
          <FiX className="w-4 h-4" />
          Clear Form
        </button>
      </div>
    </div>

    {/* Add New Slot Section */}
    <div className="mt-8 border p-4 rounded-lg bg-gray-50">
      <div className="flex items-center gap-2 mb-4">
        <FiPlus className="w-5 h-5 text-gray-600" />
        <h3 className="text-lg font-semibold text-gray-800">Add New Slots</h3>
      </div>

      <div className="space-y-6">
        {/* Single Slot Form */}
        <div className="p-4 border rounded-lg bg-white">
          <h4 className="font-medium mb-4 text-gray-700">Add Single Slot</h4>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-600">Day</label>
              <select
                value={slotForm.day}
                onChange={(e) => setSlotForm({ ...slotForm, day: e.target.value })}
                className="w-full border p-2 rounded"
              >
                <option value="">Select Day</option>
                <option value="Sunday">Sunday</option>
                <option value="Monday">Monday</option>
                <option value="Tuesday">Tuesday</option>
                <option value="Wednesday">Wednesday</option>
                <option value="Thursday">Thursday</option>
                <option value="Friday">Friday</option>
                <option value="Saturday">Saturday</option>
              </select>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-600">Date</label>
              <input
                type="date"
                value={slotForm.date}
                onChange={(e) => setSlotForm({ ...slotForm, date: e.target.value })}
                className="w-full border p-2 rounded"
              />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-600">Time</label>
              <input
                type="time"
                value={slotForm.timeSlot}
                onChange={(e) => setSlotForm({ ...slotForm, timeSlot: e.target.value })}
                className="w-full border p-2 rounded"
              />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-600">Type</label>
              <select
                value={slotForm.slotType}
                onChange={(e) => setSlotForm({ ...slotForm, slotType: e.target.value })}
                className="w-full border p-2 rounded"
              >
                <option value="home">Home Collection</option>
                <option value="center">Center Visit</option>
              </select>
            </div>
          </div>
          
          <div className="mt-4 flex gap-2">
            <button
              disabled={!slotForm.day || !slotForm.date || !slotForm.timeSlot}
              onClick={addSlot}
              className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FiPlus className="w-4 h-4" />
              Add Slot
            </button>

            <button
              onClick={() => setSlotForm({ day: "", date: "", timeSlot: "", isBooked: false, slotType: "home" })}
              className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
            >
              Clear
            </button>
          </div>
        </div>

        {/* Multiple Slots Form */}
        <div className="p-4 border rounded-lg bg-white">
          <div className="flex items-center justify-between mb-4">
            <h4 className="font-medium text-gray-700">Add Multiple Slots at Once</h4>
            <button
              onClick={addMultipleSlot}
              className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
            >
              <FiPlus className="w-4 h-4" />
              Add Slot Row
            </button>
          </div>
          
          <div className="space-y-4">
            {multipleSlots.map((slot, index) => (
              <div key={index} className="border p-3 rounded bg-gray-50">
                <div className="flex justify-between items-center mb-3">
                  <span className="font-medium text-sm">Slot {index + 1}</span>
                  {multipleSlots.length > 1 && (
                    <button
                      onClick={() => removeMultipleSlot(index)}
                      className="text-red-600 hover:text-red-800 text-sm"
                    >
                      <FiTrash2 className="w-4 h-4" />
                    </button>
                  )}
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                  <div>
                    <label className="block text-xs text-gray-600 mb-1">Day</label>
                    <select
                      value={slot.day}
                      onChange={(e) => updateMultipleSlot(index, 'day', e.target.value)}
                      className="w-full border p-2 rounded text-sm"
                    >
                      <option value="">Select Day</option>
                      <option value="Sunday">Sunday</option>
                      <option value="Monday">Monday</option>
                      <option value="Tuesday">Tuesday</option>
                      <option value="Wednesday">Wednesday</option>
                      <option value="Thursday">Thursday</option>
                      <option value="Friday">Friday</option>
                      <option value="Saturday">Saturday</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-xs text-gray-600 mb-1">Date</label>
                    <input
                      type="date"
                      value={slot.date}
                      onChange={(e) => updateMultipleSlot(index, 'date', e.target.value)}
                      className="w-full border p-2 rounded text-sm"
                    />
                  </div>

                  <div>
                    <label className="block text-xs text-gray-600 mb-1">Time</label>
                    <input
                      type="time"
                      value={slot.timeSlot}
                      onChange={(e) => updateMultipleSlot(index, 'timeSlot', e.target.value)}
                      className="w-full border p-2 rounded text-sm"
                    />
                  </div>

                  <div>
                    <label className="block text-xs text-gray-600 mb-1">Type</label>
                    <select
                      value={slot.slotType}
                      onChange={(e) => updateMultipleSlot(index, 'slotType', e.target.value)}
                      className="w-full border p-2 rounded text-sm"
                    >
                      <option value="home">Home</option>
                      <option value="center">Center</option>
                    </select>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 flex flex-wrap gap-3">
            <button
              onClick={addBulkSlots}
              disabled={multipleSlots.length === 0 || !multipleSlots.every(s => s.day && s.date && s.timeSlot && s.slotType)}
              className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FiUploadCloud className="w-4 h-4" />
              Add {multipleSlots.length} Slots
            </button>

            <button
              onClick={clearMultipleSlots}
              className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
            >
              Clear All
            </button>

            {/* Quick Add Buttons */}
            <div className="flex-1"></div>
            <div className="flex gap-2">
              <button
                onClick={() => addWeeklySlots('home')}
                className="px-3 py-2 bg-purple-100 text-purple-800 rounded hover:bg-purple-200 text-sm"
              >
                Weekly Home Slots
              </button>
              <button
                onClick={() => addWeeklySlots('center')}
                className="px-3 py-2 bg-purple-100 text-purple-800 rounded hover:bg-purple-200 text-sm"
              >
                Weekly Center Slots
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
        {activeTab === "contacts" && (
          <div>
            <h2 className="text-xl font-semibold mb-6">Contact Persons</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {diagnostic.contactPersons.map((contact) => (
                <div key={contact._id} className="border rounded-lg overflow-hidden hover:shadow-md transition-shadow">
                  <div className="bg-gray-100 p-4 flex justify-between items-center">
                    <div>
                      <h3 className="font-semibold text-lg">{contact.name}</h3>
                      <div className="flex items-center gap-2">
                        <p className="text-gray-600">{contact.designation}</p>
                        <span className="px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800 capitalize">
                          {contact.gender || 'Not specified'}
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEditContact(contact)}
                        className="text-blue-600 hover:text-blue-800"
                        title="Edit"
                      >
                        <FiEdit className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => handleDeleteContact(contact._id)}
                        className="text-red-600 hover:text-red-800"
                        title="Delete"
                      >
                        <FiTrash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>

                  <div className="p-4">
                    <div className="space-y-2">
                      <p>
                        <span className="font-medium text-sm text-gray-500">Email:</span>
                        <span className="ml-2">{contact.contactEmail || 'Not specified'}</span>
                      </p>
                      <p>
                        <span className="font-medium text-sm text-gray-500">Phone:</span>
                        <span className="ml-2">{contact.contactNumber || 'Not specified'}</span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === "branches" && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold">Branch Centers</h2>
              <button
                onClick={() => setShowAddBranchModal(true)}
                className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
              >
                <FiPlus className="w-5 h-5" />
                <span className="text-sm">Add Branch</span>
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {diagnostic.branches?.map((branch) => (
                <div key={branch._id} className="border rounded-lg overflow-hidden hover:shadow-md transition-shadow">
                  <div className="bg-blue-50 p-4 flex justify-between items-center">
                    <div>
                      <h3 className="font-semibold text-lg text-blue-800">{branch.branchName}</h3>
                      <div className="flex items-center gap-2">
                        <p className="text-blue-600 text-sm">{branch.email}</p>
                        <span className="px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800 capitalize">
                          {branch.gender || 'Both'}
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEditBranch(branch)}
                        className="text-blue-600 hover:text-blue-800"
                        title="Edit"
                      >
                        <FiEdit className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => handleDeleteBranch(branch._id)}
                        className="text-red-600 hover:text-red-800"
                        title="Delete"
                      >
                        <FiTrash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>

                  <div className="p-4">
                    <div className="space-y-3">
                      <div>
                        <h4 className="font-medium text-sm text-gray-500">Contact Info</h4>
                        <p className="text-gray-700">{branch.phone}</p>
                      </div>
                      
                      <div>
                        <h4 className="font-medium text-sm text-gray-500">Address</h4>
                        <p className="text-gray-700">{branch.address}</p>
                        <p className="text-sm text-gray-600">
                          {branch.city}, {branch.state}, {branch.country} - {branch.pincode}
                        </p>
                      </div>
                      

                      <div>
                        <h4 className="font-medium text-sm text-gray-500">Contact Persons</h4>
                        <div className="space-y-2 mt-2">
                          {branch.contactPersons?.map((contact, index) => (
                            <div key={contact._id || index} className="border-l-2 border-blue-200 pl-2">
                              <div className="flex items-center gap-2">
                                <p className="font-medium text-sm">{contact.name}</p>
                                <span className="px-1 py-0.5 rounded-full text-xs bg-purple-100 text-purple-800 capitalize">
                                  {contact.gender || 'Not specified'}
                                </span>
                              </div>
                              <p className="text-xs text-gray-600">{contact.designation}</p>
                              <p className="text-xs text-gray-600">{contact.contactNumber}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {(!diagnostic.branches || diagnostic.branches.length === 0) && (
              <div className="text-center py-8 border-2 border-dashed rounded-lg">
                <FiPlus className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                <p className="text-gray-500">No branches added yet</p>
                <button
                  onClick={() => setShowAddBranchModal(true)}
                  className="mt-2 text-blue-600 hover:text-blue-800 font-medium"
                >
                  Add your first branch
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Add Test Modal - UPDATED WITH GENDER */}
      {showAddTestModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-2xl max-h-[90vh] overflow-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Add New Test</h3>
              <button
                onClick={() => setShowAddTestModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FiX className="w-5 h-5" />
              </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Test Name*</label>
                <input
                  type="text"
                  value={newTestForm.test_name}
                  onChange={(e) => setNewTestForm({ ...newTestForm, test_name: e.target.value })}
                  className="w-full border p-2 rounded"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Gender*</label>
                <select
                  value={newTestForm.gender}
                  onChange={(e) => setNewTestForm({ ...newTestForm, gender: e.target.value })}
                  className="w-full border p-2 rounded"
                >
                  <option value="Both">Both</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">MRP (₹)*</label>
                <input
                  type="number"
                  value={newTestForm.price}
                  onChange={(e) => setNewTestForm({ ...newTestForm, price: e.target.value })}
                  className="w-full border p-2 rounded"
                  required
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Description</label>
                <textarea
                  value={newTestForm.description}
                  onChange={(e) => setNewTestForm({ ...newTestForm, description: e.target.value })}
                  className="w-full border p-2 rounded"
                  rows="3"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Instructions</label>
                <textarea
                  value={newTestForm.instruction}
                  onChange={(e) => setNewTestForm({ ...newTestForm, instruction: e.target.value })}
                  className="w-full border p-2 rounded"
                  rows="2"
                />
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={newTestForm.fastingRequired || false}
                  onChange={(e) => setNewTestForm({ ...newTestForm, fastingRequired: e.target.checked })}
                  className="mr-2"
                />
                <label className="text-sm font-medium">Fasting Required</label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={newTestForm.homeCollection || false}
                  onChange={(e) => setNewTestForm({ ...newTestForm, homeCollection: e.target.checked })}
                  className="mr-2"
                />
                <label className="text-sm font-medium">Home Collection Available</label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={newTestForm.reportIn24Hrs || false}
                  onChange={(e) => setNewTestForm({ ...newTestForm, reportIn24Hrs: e.target.checked })}
                  className="mr-2"
                />
                <label className="text-sm font-medium">Report in 24 Hours</label>
              </div>

              {!newTestForm.reportIn24Hrs && (
                <div>
                  <label className="block text-sm font-medium mb-1">Report Hours</label>
                  <input
                    type="number"
                    value={newTestForm.reportHour}
                    onChange={(e) => setNewTestForm({ ...newTestForm, reportHour: e.target.value })}
                    className="w-full border p-2 rounded"
                    placeholder="48"
                  />
                </div>
              )}
            </div>
            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => setShowAddTestModal(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleCreateTest}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              >
                Create Test
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Scan Modal - UPDATED WITH GENDER */}
      {showAddScanModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-2xl max-h-[90vh] overflow-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Add New Scan</h3>
              <button
                onClick={() => setShowAddScanModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FiX className="w-5 h-5" />
              </button>
            </div>
            
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Title *</label>
                <input
                  type="text"
                  value={newScanForm.title}
                  onChange={(e) => setNewScanForm({ ...newScanForm, title: e.target.value })}
                  className="w-full border p-2 rounded"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Gender *</label>
                <select
                  value={newScanForm.gender}
                  onChange={(e) => setNewScanForm({ ...newScanForm, gender: e.target.value })}
                  className="w-full border p-2 rounded"
                >
                  <option value="Both">Both</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">MRP (₹) *</label>
                <input
                  type="number"
                  value={newScanForm.price}
                  onChange={(e) => setNewScanForm({ ...newScanForm, price: e.target.value })}
                  className="w-full border p-2 rounded"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Preparation</label>
                <textarea
                  value={newScanForm.preparation}
                  onChange={(e) => setNewScanForm({ ...newScanForm, preparation: e.target.value })}
                  className="w-full border p-2 rounded"
                  rows="3"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Report Time</label>
                <input
                  type="text"
                  value={newScanForm.reportTime}
                  onChange={(e) => setNewScanForm({ ...newScanForm, reportTime: e.target.value })}
                  className="w-full border p-2 rounded"
                  placeholder="e.g., 24 Hours, 48 Hours"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Upload Image</label>
                <label className="flex flex-col items-center justify-center w-full h-24 border-2 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100">
                  <div className="flex flex-col items-center justify-center pt-4 pb-5">
                    <FiUploadCloud className="w-6 h-6 mb-2 text-gray-400" />
                    <p className="text-sm text-gray-500">
                      {newScanForm.image ? newScanForm.image.name : "Click to upload scan image"}
                    </p>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setNewScanForm({ ...newScanForm, image: e.target.files[0] })}
                    className="hidden"
                  />
                </label>
              </div>
            </div>
            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => setShowAddScanModal(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleCreateScan}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              >
                Create Scan
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modals */}
      {/* Test Edit Modal - UPDATED WITH GENDER */}
      {editingTest && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-2xl max-h-[90vh] overflow-auto">
            <h3 className="text-lg font-semibold mb-4">Edit Test</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Test Name</label>
                <input
                  type="text"
                  value={testForm.name}
                  onChange={(e) => setTestForm({ ...testForm, name: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Gender</label>
                <select
                  value={testForm.gender}
                  onChange={(e) => setTestForm({ ...testForm, gender: e.target.value })}
                  className="w-full border p-2 rounded"
                >
                  <option value="Both">Both</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">MRP (₹)</label>
                <input
                  type="number"
                  value={testForm.price}
                  onChange={(e) => setTestForm({ ...testForm, price: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Description</label>
                <textarea
                  value={testForm.description}
                  onChange={(e) => setTestForm({ ...testForm, description: e.target.value })}
                  className="w-full border p-2 rounded"
                  rows="3"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Instructions</label>
                <textarea
                  value={testForm.instruction}
                  onChange={(e) => setTestForm({ ...testForm, instruction: e.target.value })}
                  className="w-full border p-2 rounded"
                  rows="3"
                />
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={testForm.fastingRequired}
                  onChange={(e) => setTestForm({ ...testForm, fastingRequired: e.target.checked })}
                  className="mr-2"
                />
                <label className="text-sm font-medium">Fasting Required</label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={testForm.homeCollectionAvailable}
                  onChange={(e) => setTestForm({ ...testForm, homeCollectionAvailable: e.target.checked })}
                  className="mr-2"
                />
                <label className="text-sm font-medium">Home Collection Available</label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={testForm.reportIn24Hrs}
                  onChange={(e) => setTestForm({ ...testForm, reportIn24Hrs: e.target.checked })}
                  className="mr-2"
                />
                <label className="text-sm font-medium">Report in 24 Hours</label>
              </div>
              {!testForm.reportIn24Hrs && (
                <div>
                  <label className="block text-sm font-medium mb-1">Report Hours</label>
                  <input
                    type="number"
                    value={testForm.reportHour}
                    onChange={(e) => setTestForm({ ...testForm, reportHour: e.target.value })}
                    className="w-full border p-2 rounded"
                  />
                </div>
              )}
            </div>
            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => setEditingTest(null)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateTest}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Update Test
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Package Edit Modal - UPDATED WITH GENDER */}
      {editingPackage && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl max-h-[90vh] overflow-auto">
            <h3 className="text-lg font-semibold mb-4">Edit Package</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Package Name</label>
                <input
                  type="text"
                  value={packageForm.name}
                  onChange={(e) => setPackageForm({ ...packageForm, name: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Gender</label>
                <select
                  value={packageForm.gender}
                  onChange={(e) => setPackageForm({ ...packageForm, gender: e.target.value })}
                  className="w-full border p-2 rounded"
                >
                  <option value="Both">Both</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">MRP (₹)</label>
                <input
                  type="number"
                  value={packageForm.price}
                  onChange={(e) => setPackageForm({ ...packageForm, price: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Total Tests Included</label>
                <input
                  type="number"
                  value={packageForm.totalTestsIncluded}
                  onChange={(e) => setPackageForm({ ...packageForm, totalTestsIncluded: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Description</label>
                <textarea
                  value={packageForm.description}
                  onChange={(e) => setPackageForm({ ...packageForm, description: e.target.value })}
                  className="w-full border p-2 rounded"
                  rows="3"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Precautions</label>
                <textarea
                  value={packageForm.precautions}
                  onChange={(e) => setPackageForm({ ...packageForm, precautions: e.target.value })}
                  className="w-full border p-2 rounded"
                  rows="3"
                />
              </div>
              <div className="md:col-span-2">
                <div className="flex justify-between items-center mb-2">
                  <h4 className="font-semibold">Included Tests</h4>
                  <button
                    onClick={addPackageTest}
                    className="flex items-center gap-1 text-blue-600 text-sm"
                  >
                    <FiPlus className="w-4 h-4" /> Add Test
                  </button>
                </div>
                {packageForm.includedTests.map((test, index) => (
                  <div key={index} className="border p-4 rounded mb-4">
                    <div className="flex justify-between items-center mb-2">
                      <h5 className="font-medium">Test {index + 1}</h5>
                      <button
                        onClick={() => removePackageTest(index)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <FiTrash2 className="w-4 h-4" />
                      </button>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                      <div>
                        <label className="block text-sm font-medium mb-1">Test Name</label>
                        <input
                          type="text"
                          value={test.name}
                          onChange={(e) => handlePackageTestChange(index, "name", e.target.value )}
                          className="w-full border p-2 rounded"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-1">Sub Test Count</label>
                        <input
                          type="number"
                          value={test.subTestCount}
                          onChange={(e) => handlePackageTestChange(index, "subTestCount", e.target.value)}
                          className="w-full border p-2 rounded"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <label className="block text-sm font-medium">Sub Tests</label>
                        <button
                          onClick={() => addSubTest(index)}
                          className="flex items-center gap-1 text-green-600 text-sm"
                        >
                          <FiPlus className="w-3 h-3" /> Add Sub Test
                        </button>
                      </div>
                      {test.subTests.map((subTest, subIndex) => (
                        <div key={subIndex} className="flex gap-2 mb-2">
                          <input
                            type="text"
                            value={subTest}
                            onChange={(e) => handlePackageSubTestChange(index, subIndex, e.target.value)}
                            className="flex-1 border p-2 rounded"
                            placeholder={`Sub test ${subIndex + 1}`}
                          />
                          <button
                            onClick={() => removeSubTest(index, subIndex)}
                            className="text-red-600 hover:text-red-800 px-2"
                          >
                            <FiMinus className="w-4 h-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => setEditingPackage(null)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdatePackage}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Update Package
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Scan Edit Modal - UPDATED WITH GENDER */}
      {editingScan && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-2xl max-h-[90vh] overflow-auto">
            <h3 className="text-lg font-semibold mb-4">Edit Scan</h3>
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Title</label>
                <input
                  type="text"
                  value={scanForm.title}
                  onChange={(e) => setScanForm({ ...scanForm, title: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Gender</label>
                <select
                  value={scanForm.gender}
                  onChange={(e) => setScanForm({ ...scanForm, gender: e.target.value })}
                  className="w-full border p-2 rounded"
                >
                  <option value="Both">Both</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">MRP (₹)</label>
                <input
                  type="number"
                  value={scanForm.price}
                  onChange={(e) => setScanForm({ ...scanForm, price: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Preparation Instructions</label>
                <textarea
                  value={scanForm.preparation}
                  onChange={(e) => setScanForm({ ...scanForm, preparation: e.target.value })}
                  className="w-full border p-2 rounded"
                  rows="3"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Report Time</label>
                <input
                  type="text"
                  value={scanForm.reportTime}
                  onChange={(e) => setScanForm({ ...scanForm, reportTime: e.target.value })}
                  className="w-full border p-2 rounded"
                  placeholder="e.g., 24 Hours, 48 Hours"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Image URL</label>
                <input
                  type="text"
                  value={scanForm.image}
                  onChange={(e) => setScanForm({ ...scanForm, image: e.target.value })}
                  className="w-full border p-2 rounded"
                  placeholder="https://example.com/image.jpg"
                />
              </div>
            </div>
            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => setEditingScan(null)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateScan}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Update Scan
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Contact Edit Modal */}
      {editingContact && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-2xl max-h-[90vh] overflow-auto">
            <h3 className="text-lg font-semibold mb-4">Edit Contact</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Name</label>
                <input
                  type="text"
                  value={contactForm.name}
                  onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Designation</label>
                <input
                  type="text"
                  value={contactForm.designation}
                  onChange={(e) => setContactForm({ ...contactForm, designation: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Gender</label>
                <select
                  value={contactForm.gender}
                  onChange={(e) => setContactForm({ ...contactForm, gender: e.target.value })}
                  className="w-full border p-2 rounded"
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Email</label>
                <input
                  type="email"
                  value={contactForm.contactEmail}
                  onChange={(e) => setContactForm({ ...contactForm, contactEmail: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Contact Number</label>
                <input
                  type="text"
                  value={contactForm.contactNumber}
                  onChange={(e) => setContactForm({ ...contactForm, contactNumber: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>
            </div>
            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => setEditingContact(null)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateContact}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Update Contact
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Package Modal - UPDATED WITH GENDER */}
      {showAddPackageModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl max-h-[90vh] overflow-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Add New Package</h3>
              <button
                onClick={() => setShowAddPackageModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FiX className="w-5 h-5" />
              </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Package Name *</label>
                <input
                  type="text"
                  name="name"
                  value={newPackageForm.name}
                  onChange={handleNewPackageChange}
                  className="w-full border p-2 rounded"
                  placeholder="Enter package name"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1">Gender *</label>
                <select
                  name="gender"
                  value={newPackageForm.gender}
                  onChange={handleNewPackageChange}
                  className="w-full border p-2 rounded"
                >
                  <option value="Both">Both</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1">MRP (₹) *</label>
                <input
                  type="number"
                  name="price"
                  value={newPackageForm.price}
                  onChange={handleNewPackageChange}
                  className="w-full border p-2 rounded"
                  placeholder="Enter price"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1">Total Tests Included *</label>
                <input
                  type="number"
                  name="totalTestsIncluded"
                  value={newPackageForm.totalTestsIncluded}
                  onChange={handleNewPackageChange}
                  className="w-full border p-2 rounded"
                  placeholder="Number of tests"
                />
              </div>
              
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Description *</label>
                <textarea
                  name="description"
                  value={newPackageForm.description}
                  onChange={handleNewPackageChange}
                  className="w-full border p-2 rounded"
                  rows="3"
                  placeholder="Enter package description"
                />
              </div>
              
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Precautions *</label>
                <textarea
                  name="precautions"
                  value={newPackageForm.precautions}
                  onChange={handleNewPackageChange}
                  className="w-full border p-2 rounded"
                  rows="3"
                  placeholder="Enter precautions"
                />
              </div>
              
              <div className="md:col-span-2">
                <div className="flex justify-between items-center mb-2">
                  <h4 className="font-semibold">Included Tests *</h4>
                  <button
                    onClick={addNewPackageTest}
                    className="flex items-center gap-1 text-blue-600 text-sm"
                  >
                    <FiPlus className="w-4 h-4" /> Add Test
                  </button>
                </div>
                
                {newPackageForm.includedTests.map((test, index) => (
                  <div key={index} className="border p-4 rounded mb-4">
                    <div className="flex justify-between items-center mb-2">
                      <h5 className="font-medium">Test {index + 1}</h5>
                      <button
                        onClick={() => removeNewPackageTest(index)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <FiTrash2 className="w-4 h-4" />
                      </button>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                      <div>
                        <label className="block text-sm font-medium mb-1">Test Name *</label>
                        <input
                          type="text"
                          value={test.name}
                          onChange={(e) => handleNewPackageTestChange(index, "name", e.target.value)}
                          className="w-full border p-2 rounded"
                          placeholder="Enter test name"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium mb-1">Sub Test Count</label>
                        <input
                          type="number"
                          value={test.subTestCount}
                          onChange={(e) => handleNewPackageTestChange(index, "subTestCount", e.target.value)}
                          className="w-full border p-2 rounded"
                          placeholder="Number of sub-tests"
                        />
                      </div>
                    </div>
                    
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <label className="block text-sm font-medium">Sub Tests</label>
                        <button
                          onClick={() => addNewSubTest(index)}
                          className="flex items-center gap-1 text-green-600 text-sm"
                        >
                          <FiPlus className="w-3 h-3" /> Add Sub Test
                        </button>
                      </div>
                      
                      {test.subTests.map((subTest, subIndex) => (
                        <div key={subIndex} className="flex gap-2 mb-2">
                          <input
                            type="text"
                            value={subTest}
                            onChange={(e) => handleNewPackageSubTestChange(index, subIndex, e.target.value)}
                            className="flex-1 border p-2 rounded"
                            placeholder={`Sub test ${subIndex + 1}`}
                          />
                          <button
                            onClick={() => removeNewSubTest(index, subIndex)}
                            className="text-red-600 hover:text-red-800 px-2"
                          >
                            <FiMinus className="w-4 h-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => setShowAddPackageModal(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleCreatePackage}
                disabled={!newPackageForm.name || !newPackageForm.price || !newPackageForm.description || !newPackageForm.precautions || newPackageForm.includedTests.length === 0}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Create Package
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Branch Modal - UPDATED WITH GENDER */}
      {(showAddBranchModal || editingBranch) && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl max-h-[90vh] overflow-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">
                {editingBranch ? "Edit Branch" : "Add New Branch"}
              </h3>
              <button
                onClick={() => {
                  setShowAddBranchModal(false);
                  setEditingBranch(null);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <FiX className="w-5 h-5" />
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Branch Name *</label>
                <input
                  type="text"
                  value={branchForm.branchName}
                  onChange={(e) => setBranchForm({ ...branchForm, branchName: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Gender *</label>
                <select
                  value={branchForm.gender}
                  onChange={(e) => setBranchForm({ ...branchForm, gender: e.target.value })}
                  className="w-full border p-2 rounded"
                >
                  <option value="Both">Both</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Email *</label>
                <input
                  type="email"
                  value={branchForm.email}
                  onChange={(e) => setBranchForm({ ...branchForm, email: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Phone *</label>
                <input
                  type="text"
                  value={branchForm.phone}
                  onChange={(e) => setBranchForm({ ...branchForm, phone: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Country *</label>
                <input
                  type="text"
                  value={branchForm.country}
                  onChange={(e) => setBranchForm({ ...branchForm, country: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">State *</label>
                <input
                  type="text"
                  value={branchForm.state}
                  onChange={(e) => setBranchForm({ ...branchForm, state: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">City *</label>
                <input
                  type="text"
                  value={branchForm.city}
                  onChange={(e) => setBranchForm({ ...branchForm, city: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Pincode *</label>
                <input
                  type="text"
                  value={branchForm.pincode}
                  onChange={(e) => setBranchForm({ ...branchForm, pincode: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Full Address *</label>
                <textarea
                  value={branchForm.address}
                  onChange={(e) => setBranchForm({ ...branchForm, address: e.target.value })}
                  className="w-full border p-2 rounded"
                  rows="3"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Location URL *</label>
                <input
                  type="text"
                  value={branchForm.locationUrl}
                  onChange={(e) => setBranchForm({ ...branchForm, locationUrl: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>

              <div className="md:col-span-2">
                <div className="flex justify-between items-center mb-2">
                  <h4 className="font-semibold">Contact Persons</h4>
                  <button
                    onClick={handleAddBranchContact}
                    className="flex items-center gap-1 text-blue-600 text-sm"
                  >
                    <FiPlus className="w-4 h-4" /> Add Contact
                  </button>
                </div>

                {branchForm.contactPersons.map((contact, index) => (
                  <div key={index} className="border p-4 rounded mb-4">
                    <div className="flex justify-between items-center mb-3">
                      <h5 className="font-medium">Contact Person {index + 1}</h5>
                      {branchForm.contactPersons.length > 1 && (
                        <button
                          onClick={() => handleRemoveBranchContact(index)}
                          className="text-red-600 hover:text-red-800"
                        >
                          <FiTrash2 className="w-4 h-4" />
                        </button>
                      )}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium mb-1">Name *</label>
                        <input
                          type="text"
                          value={contact.name}
                          onChange={(e) => handleBranchContactChange(index, "name", e.target.value)}
                          className="w-full border p-2 rounded"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">Designation *</label>
                        <input
                          type="text"
                          value={contact.designation}
                          onChange={(e) => handleBranchContactChange(index, "designation", e.target.value)}
                          className="w-full border p-2 rounded"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">Gender *</label>
                        <select
                          value={contact.gender}
                          onChange={(e) => handleBranchContactChange(index, "gender", e.target.value)}
                          className="w-full border p-2 rounded"
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">Email *</label>
                        <input
                          type="email"
                          value={contact.contactEmail}
                          onChange={(e) => handleBranchContactChange(index, "contactEmail", e.target.value)}
                          className="w-full border p-2 rounded"
                        />
                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-sm font-medium mb-1">Contact Number *</label>
                        <input
                          type="text"
                          value={contact.contactNumber}
                          onChange={(e) => handleBranchContactChange(index, "contactNumber", e.target.value)}
                          className="w-full border p-2 rounded"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => {
                  setShowAddBranchModal(false);
                  setEditingBranch(null);
                }}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleCreateOrUpdateBranch}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                {editingBranch ? "Update Branch" : "Create Branch"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Slot Edit Modal - UPDATED WITH GENDER */}
      {editingSlot && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-md">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Edit Slot</h3>
              <button
                onClick={() => setEditingSlot(null)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FiX className="w-5 h-5" />
              </button>
            </div>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Day</label>
                <select
                  value={slotForm.day}
                  onChange={(e) => setSlotForm({ ...slotForm, day: e.target.value })}
                  className="w-full border p-2 rounded"
                >
                  <option value="">Select Day</option>
                  <option value="Sunday">Sunday</option>
                  <option value="Monday">Monday</option>
                  <option value="Tuesday">Tuesday</option>
                  <option value="Wednesday">Wednesday</option>
                  <option value="Thursday">Thursday</option>
                  <option value="Friday">Friday</option>
                  <option value="Saturday">Saturday</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Gender</label>
                <select
                  value={slotForm.gender}
                  onChange={(e) => setSlotForm({ ...slotForm, gender: e.target.value })}
                  className="w-full border p-2 rounded"
                >
                  <option value="Both">Both</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Date</label>
                <input
                  type="date"
                  value={slotForm.date}
                  onChange={(e) => setSlotForm({ ...slotForm, date: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Time</label>
                <input
                  type="time"
                  value={slotForm.timeSlot}
                  onChange={(e) => setSlotForm({ ...slotForm, timeSlot: e.target.value })}
                  className="w-full border p-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Type</label>
                <select
                  value={slotForm.slotType}
                  onChange={(e) => setSlotForm({ ...slotForm, slotType: e.target.value })}
                  className="w-full border p-2 rounded"
                >
                  <option value="home">Home Collection</option>
                  <option value="center">Center Visit</option>
                </select>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={slotForm.isBooked}
                  onChange={(e) => setSlotForm({ ...slotForm, isBooked: e.target.checked })}
                  className="mr-2"
                  id="isBooked"
                />
                <label htmlFor="isBooked" className="text-sm font-medium">
                  Mark as Booked
                </label>
              </div>
            </div>

            <div className="flex justify-end gap-2 mt-6">
              <button
                onClick={() => setEditingSlot(null)}
                className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={updateSlot}
                disabled={!slotForm.day || !slotForm.date || !slotForm.timeSlot}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Update Slot
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DiagnosticDetail;